import React from "react";

function Canvas() {

    return (
        <div id="canvas">
            <canvas id="chart" width="250" height="200"></canvas>
            <div id="regression"></div>
        </div>
    )
};

export default Canvas;